import { render, staticRenderFns } from "./ModalJoin.vue?vue&type=template&id=2926d4c3&"
import script from "./ModalJoin.vue?vue&type=script&lang=js&"
export * from "./ModalJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports